
import React from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface ActionButtonsProps {
  paymentUrl: string | null;
  status: string;
  subscriptionId: string;
  onCancelClick: (id: string) => void;
  schoolId?: string;
  infradigitalConfig?: { bill_url: string; biller_code: string } | null;
  hasUnpaidBills?: boolean;
}

export function ActionButtons({ 
  paymentUrl, 
  status, 
  subscriptionId, 
  onCancelClick,
  schoolId,
  infradigitalConfig,
  hasUnpaidBills = false
}: ActionButtonsProps) {
  // Create payment URL directly from schoolId and infradigital config if available
  const paymentUrlToUse = paymentUrl || (
    hasUnpaidBills && infradigitalConfig && schoolId 
      ? `${infradigitalConfig.bill_url}?biller_code=${infradigitalConfig.biller_code}&bill_key=${schoolId}`
      : null
  );

  return (
    <div className="flex flex-col space-y-2 justify-center">
      {paymentUrlToUse && (
        <Button 
          className="bg-teal-600 hover:bg-teal-700" 
          onClick={() => window.open(paymentUrlToUse, '_blank')}
        >
          Pembayaran
        </Button>
      )}
      
      {(['active', 'pending', 'past_due'].includes(status)) && (
        <Button 
          variant="outline"
          className="border-red-300 text-red-600 hover:bg-red-50"
          onClick={() => onCancelClick(subscriptionId)}
        >
          <X className="h-4 w-4 mr-1" />
          Cancel Subscription
        </Button>
      )}
    </div>
  );
}
